"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeBaseUrl = exports.getBaseUrl = exports.createOption = exports.CALLAPI_REJECT_REASON = void 0;
exports.withCallAPI = withCallAPI;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _APIs = require("../../constants/APIs");
var _labelConsts = require("../../constants/labelConsts");
var _emptyCheck = _interopRequireDefault(require("../../logics/emptyCheck"));
var _envUtil = _interopRequireWildcard(require("../../logics/envUtil"));
var _sendLog = require("../../logics/sendLog");
var _coreInfoBarActions = require("../../reducers/coreInfoBarActions");
var _coreLoginInfoActions = require("../../reducers/coreLoginInfoActions");
var _CustomRouter = require("./CustomRouter");
var _stringConsts = require("01_core/constants/stringConsts");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CALLAPI_REJECT_REASON = exports.CALLAPI_REJECT_REASON = {
  CALLING: 'CALLING',
  UNMOUNTED: 'UNMOUNTED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  OTHERS: 'OTHERS'
};

/**
 * API呼び出し共通部品
 * 　APIを呼び出したいコンポーネントをラップするとcallAPIプロパティにAPI呼び出し関数がセットされる。
 *
 */
function withCallAPI(WrappedComponent) {
  class CallAPI extends _react.default.Component {
    constructor(props) {
      var _this;
      super(props);
      _this = this;
      _defineProperty(this, "unauthorized", 'unauthorized');
      _defineProperty(this, "isMounted", false);
      _defineProperty(this, "showCallingMessage", isShow => {
        this.setState({
          isShowCallingMessage: isShow
        });
      });
      _defineProperty(this, "callAPI", function (url, body, token, functionId) {
        let rawResponse = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        let multipart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        const {
          openInfoBar,
          removeSessionId,
          intl,
          sessionId
        } = _this.props;
        if (_this.state.isCalling[url]) {
          if (_this.state.isShowCallingMessage) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_DOUBLE_SUBMIT
            }));
          }
          console.log('callAPI rejected. reason: CALLING', ' [', url, ']');
          return Promise.reject({
            reason: CALLAPI_REJECT_REASON.CALLING
          });
        }
        const err = new Error();
        _this.setState(state => ({
          isCalling: _objectSpread(_objectSpread({}, state.isCalling), {}, {
            [url]: true
          })
        }));
        return _this.postData(url, body, token, err, functionId, rawResponse, multipart).then(response => {
          if (!_this.isMounted) {
            return Promise.reject({
              reason: CALLAPI_REJECT_REASON.UNMOUNTED
            });
          }
          if (response.status === _this.unauthorized) {
            removeSessionId();
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_UNAUTHORIZED
            }));
            // 401の場合、ログアウト扱いとする（トークン期限切れによる401対応）
            return Promise.resolve(response);
          }
          if (response.status === _APIs.STATUS.ERROR) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
          }
          return Promise.resolve(response);
        }).catch(error => {
          if (error.reason === CALLAPI_REJECT_REASON.UNMOUNTED) {
            console.log('callAPI rejected. reason: UNMOUNTED', ' [', url, ']');
            return Promise.reject(error);
          } else {
            (0, _sendLog.sendErrorLog)(sessionId, 'CallAPI Error', error);
            console.log('callAPI rejected. reason: OTHERS, message: ', error.toString(), ' [', url, ']');
            return Promise.reject({
              reason: CALLAPI_REJECT_REASON.OTHERS,
              message: error.toString()
            });
          }
        });
      });
      _defineProperty(this, "callAPIRawResponse", (url, body, token, functionId) => {
        return this.callAPI(url, body, token, functionId, true, false);
      });
      _defineProperty(this, "callAPIMultipart", (url, body, token, functionId) => {
        return this.callAPIMP(url, body, token, functionId, false, true);
      });
      _defineProperty(this, "callAPIMP", function (url, body, token, functionId) {
        let rawResponse = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        let multipart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        const {
          openInfoBar,
          removeSessionId,
          intl,
          sessionId
        } = _this.props;
        if (_this.state.isCalling[url]) {
          if (_this.state.isShowCallingMessage) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_DOUBLE_SUBMIT
            }));
          }
          console.log('callAPI rejected. reason: CALLING', ' [', url, ']');
          return Promise.reject({
            reason: CALLAPI_REJECT_REASON.CALLING
          });
        }
        const err = new Error();
        _this.setState(state => ({
          isCalling: _objectSpread(_objectSpread({}, state.isCalling), {}, {
            [url]: true
          })
        }));
        return _this.postData(url, body, token, err, functionId, rawResponse, multipart).then(response => {
          if (!_this.isMounted) {
            return Promise.reject({
              reason: CALLAPI_REJECT_REASON.UNMOUNTED
            });
          }
          if (response.status === _this.unauthorized) {
            removeSessionId();
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_UNAUTHORIZED
            }));
            throw err;
          }
          if (response.status === _APIs.STATUS.ERROR) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
          }
          return Promise.resolve(response);
        }).catch(error => {
          if (error.reason === CALLAPI_REJECT_REASON.UNMOUNTED) {
            console.log('callAPI rejected. reason: UNMOUNTED', ' [', url, ']');
            return Promise.reject(error);
          } else {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_FILE_SIZE_LARGE_MESSAGE
            }));
            (0, _sendLog.sendErrorLog)(sessionId, 'CallAPI Error', error);
            console.log('callAPI rejected. reason: OTHERS, message: ', error.toString(), ' [', url, ']');
            return Promise.reject({
              reason: CALLAPI_REJECT_REASON.OTHERS,
              message: error.toString()
            });
          }
        });
      });
      _defineProperty(this, "postData", (url, data, token, err, functionId, rawResponse, multipart) => {
        const sessionId = this.props.sessionId ? this.props.sessionId : token;
        const commonBody = {
          commonLanguage: this.props.language,
          functionId: functionId ? functionId : this.props.history.location.pathname.substr(1)
        };
        const option = createOption(sessionId, data, commonBody, multipart);
        const baseUrl = getBaseUrl();
        return fetch(baseUrl + url, option).then(response => {
          if (this.isMounted) {
            this.setState(state => ({
              isCalling: _objectSpread(_objectSpread({}, state.isCalling), {}, {
                [url]: false
              })
            }));
          }
          if (response.ok) {
            let contentType = response.headers.get('content-type');
            if (!rawResponse) {
              if (contentType && contentType.includes('application/json')) {
                return response.json().then(json => {
                  return Promise.resolve(json);
                }).catch(e => {
                  err.message = 'JSON解析失敗';
                  console.warn(err.message, e);
                  throw err;
                });
              } else {
                err.message = 'Response解析失敗';
                console.warn(err.message);
                throw err;
              }
            } else {
              return response;
            }
          }
          if (response.status === 401) {
            return Promise.resolve({
              status: this.unauthorized
            });
          }
          err.message = response.status;
          throw err;
        }).catch(e => {
          if (this.isMounted) {
            this.setState({
              isCalling: {}
            });
          }
          console.error('CallAPI - ERROR - STATUS', e);
          err.message = e.message;
          throw err;
        });
      });
      this.state = {
        isCalling: {},
        isShowCallingMessage: true
      };
    }
    componentDidMount() {
      this.isMounted = true;
    }
    componentWillUnmount() {
      this.isMounted = false;
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
        callAPI: this.callAPI,
        callAPIRawResponse: this.callAPIRawResponse,
        callAPIMultipart: this.callAPIMultipart
      }, this.props, {
        callAPIShowCallingMessage: this.showCallingMessage
      }));
    }
  }
  const mapStateToProps = state => {
    return {
      sessionId: state.coreLoginInfo.sessionId,
      language: state.coreLocale.language
    };
  };
  const mapDispatchToProps = dispatch => ({
    removeSessionId: () => dispatch(_coreLoginInfoActions.coreLoginInfoActions[_coreLoginInfoActions.TYPES_LOGIN_INFO.REMOVE_SESSION_ID]()),
    setSessionId: sessionId => dispatch(_coreLoginInfoActions.coreLoginInfoActions[_coreLoginInfoActions.TYPES_LOGIN_INFO.SET_SESSION_ID](sessionId)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  });
  CallAPI = (0, _CustomRouter.withRouter)(CallAPI);
  CallAPI = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CallAPI);
  CallAPI = (0, _reactIntl.injectIntl)(CallAPI);
  return CallAPI;
}

/**
 * Optionの生成（外部から呼び出しあり）
 */
const createOption = (sessionId, data, commonBody, multipart) => {
  let option = {
    cache: 'no-cache',
    credentials: 'same-origin',
    mode: 'cors',
    redirect: 'follow',
    referrer: 'no-referrer',
    method: 'POST',
    body: data
  };
  if (multipart) {
    option.headers = {
      authorization: sessionId ? 'bearer ' + sessionId : _stringConsts.STRING_CONSTS.EMPTY
    };
  } else {
    option.headers = {
      'content-type': 'application/json',
      authorization: sessionId ? 'bearer ' + sessionId : _stringConsts.STRING_CONSTS.EMPTY
    };
  }
  if (data != null) {
    if (multipart) {
      Object.keys(commonBody).map(key => option.body.append(key, commonBody[key]));
    } else {
      const body = {
        body: JSON.stringify(_objectSpread(_objectSpread({}, (0, _emptyCheck.default)(data)), commonBody))
      };
      Object.assign(option, body);
    }
  } else {
    Object.assign(option, {
      body: JSON.stringify(commonBody)
    });
  }
  return option;
};
exports.createOption = createOption;
const getBaseUrl = () => {
  if (_envUtil.default.getEnv(_envUtil.ENV_KEY.USE_RELATE_PATH)) {
    return '';
  }
  return makeBaseUrl();
};
exports.getBaseUrl = getBaseUrl;
let baseUrlCache = null;
const makeBaseUrl = () => {
  if (baseUrlCache !== null) {
    return baseUrlCache;
  }
  let baseUrl = _envUtil.default.getEnv(_envUtil.ENV_KEY.PROTOCOL);
  baseUrl += _envUtil.default.getEnv(_envUtil.ENV_KEY.INTERNET_HOST);
  let port = _envUtil.default.getEnv(_envUtil.ENV_KEY.PORT);
  if (port && port !== '' && port !== '80') {
    baseUrl += ':' + port;
  }
  baseUrlCache = baseUrl;
  return baseUrl;
};
exports.makeBaseUrl = makeBaseUrl;